export default __webpack_public_path__ + "static/media/silubi-symbol.a960fbd9.svg";